import { render, staticRenderFns } from "./stretch-full.vue?vue&type=template&id=707cfa52&scoped=true"
import script from "./stretch-full.vue?vue&type=script&lang=js"
export * from "./stretch-full.vue?vue&type=script&lang=js"
import style0 from "./stretch-full.vue?vue&type=style&index=0&id=707cfa52&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707cfa52",
  null
  
)

export default component.exports